// Components/projects/Data.js
import clive from "../../assets/clive.png";
import vg from "../../assets/vg.webp";
import inensoBg from "../../assets/logo.png";
import inenso from "../../assets/inenso.webp";
import therapix from "../../assets/therapix/therapix.webp";
import therapixCover from "../../assets/therapix/cover.jpg";
import shotPlaceholder from "../../assets/duck.png";
import waste from "../../assets/wastematch/waste.png";
import wasterBg from "../../assets/wastematch/wastebackground.png";
import example from "../../assets/inenso.mp4";
import vgVideo from "../../assets/vgVideo.mp4";
// import vgbg from "../../assets/vgbg.png";
import inensoVg from "../../assets/inenso.mp4";
import vgbg from "../../assets/vgCover.webp";
export const projectsData = [
  {
    id: 10,
    slug: "therapix-ai",
    image: therapix,
    title: "Therapix AI",
    category: "health-tech / ai",
    cover: therapixCover,
    video: example,
    summary:
      "Generative AI platform that enables physiotherapists to design, customize, and share personalized exercise routines with patients using video driven workflows.",
    role: "Founder / Full-stack Developer",
    timeframe: "2024 - Present",
    status: "In Development",

    links: {
      demo: "",
      repo: "https://github.com/BuchiNy/hackathon/tree/Main/amplify/backend",
      docs: "",
    },
    stackSummary: [
      { k: "Compute", v: "AWS Lambda + Azure AI Foundry" },
      { k: "Ingress", v: "API Gateway" },
      { k: "Egress", v: "AppSync" },
      { k: "Data", v: "DynamoDB" },
      { k: "Storage", v: "S3" },
      { k: "Auth", v: "Amazon Cognito" },
      { k: "Async", v: "Lambda Step Functions, SQS + DLQ" },
      { k: "IaC", v: "CloudFormation" },
      { k: "CI/CD", v: "GitHub Actions" },
      { k: "Observability", v: "CloudWatch + X-Ray" },
      { k: "Security", v: "Least-privilege IAM + Secrets Manager" },
    ],

    overview: [
      {
        title: "Problem",
        description:
          "Physiotherapists rely on static handouts or limited exercise libraries that make it difficult for patients to remember exercises correctly and for therapists to tailor routines to individual needs.",
      },
      {
        title: "Solution",
        description:
          "An intelligent exercise design platform that allows therapists to generate and customize demonstration videos from prompts or reference footage within a guided clinical workflow.",
      },
    ],
    responsibilities: [
      "Defined product vision based on first hand physiotherapy experience",
      "Designed end to end exercise creation and delivery workflow",
      "Built backend services for exercise generation and plan management",
      "Integrated AI powered video generation pipeline",
      "Implemented patient plan delivery and tracking logic",
    ],
    features: [
      "AI generated physiotherapy exercise videos from prompts",
      "Reference video upload with guided customization",
      "Multi angle exercise demonstrations",
      "Customization by injury type age group and difficulty",
      "Review and refinement loop before publishing",
      "Structured exercise plans shared directly with patients",
    ],

    highlights: [
      "PR checks: unit tests, lint, security scan",
      "Deployments: dev → staging → prod with approvals",
      "Resilience: retries, DLQ, idempotency keys",
      "Cost controls: DynamoDB TTL, Lambda reserved concurrency",
    ],

    engineeringDecisions: [
      {
        title: "DynamoDB over RDS",
        description:
          "Chosen for predictable scaling and simple access patterns. Native Integration with AppSync for Egress Real time events",
      },
      {
        title: "Async via SQS and Step Functions",
        description:
          "Long-running side effects (AI Video Gen) moved off the request path to keep app usable and isolate failures.",
      },
    ],

    architecture: [
      {
        key: "overall-infra",
        title: "Overall system infrastructure",
        description:
          "Clients authenticate with Amazon Cognito. Authenticated requests go to AWS AppSync (GraphQL) for data in Amazon DynamoDB and to Amazon API Gateway for job orchestration via AWS Lambda. Lambda calls Azure AI Foundry for AI processing and stores generated videos in Amazon S3.",
        svg: {
          viewBox: "0 0 1200 520",
          nodes: [
            // Client
            {
              id: "web",
              type: "box",
              x: 40,
              y: 210,
              w: 160,
              h: 70,
              label: "Web App",
              vendor: "Client",
            },
            {
              id: "mobile",
              type: "box",
              x: 40,
              y: 310,
              w: 160,
              h: 70,
              label: "Mobile App",
              vendor: "Client",
            },

            // Auth
            {
              id: "cognito",
              type: "box",
              x: 240,
              y: 260,
              w: 190,
              h: 80,
              label: "Amazon Cognito",
              sub: "AuthN/AuthZ",
              vendor: "AWS",
            },

            // API layer
            {
              id: "appsync",
              type: "box",
              x: 470,
              y: 200,
              w: 190,
              h: 80,
              label: "AWS AppSync",
              sub: "GraphQL API",
              vendor: "AWS",
            },
            {
              id: "apigw",
              type: "box",
              x: 470,
              y: 330,
              w: 190,
              h: 80,
              label: "Amazon API Gateway",
              sub: "REST/HTTP API",
              vendor: "AWS",
            },

            // Compute
            {
              id: "lambda",
              type: "box",
              x: 700,
              y: 330,
              w: 180,
              h: 80,
              label: "AWS Lambda",
              sub: "Orchestrate AI jobs",
              vendor: "AWS",
            },

            // Data + storage
            {
              id: "ddb",
              type: "box",
              x: 700,
              y: 200,
              w: 180,
              h: 80,
              label: "Amazon DynamoDB",
              sub: "System data",
              vendor: "AWS",
            },
            {
              id: "s3",
              type: "box",
              x: 940,
              y: 330,
              w: 200,
              h: 80,
              label: "Amazon S3",
              sub: "Generated videos",
              vendor: "AWS",
            },

            // Azure
            {
              id: "azureFoundry",
              type: "box",
              x: 940,
              y: 170,
              w: 200,
              h: 90,
              label: "Azure AI Foundry",
              sub: "AI generation/inference",
              vendor: "Azure",
            },
          ],
          edges: [
            // Clients -> Cognito (sign-in / token)
            { id: "e1", d: "M200 245 L240 245", dotDur: 2.2 },
            { id: "e2", d: "M200 345 L240 345", dotDur: 2.3 },

            // Cognito -> AppSync / API GW (token used to access)
            { id: "e3", d: "M430 285 L470 240", dotDur: 2.4 },
            { id: "e4", d: "M430 315 L470 370", dotDur: 2.5 },

            // Web/Mobile -> AppSync (GraphQL operations)
            { id: "e5", d: "M200 235 L470 235", dotDur: 2.6 },
            { id: "e6", d: "M200 335 L470 235", dotDur: 2.8 },

            // Web/Mobile -> API Gateway (job requests)
            { id: "e7", d: "M200 255 L470 370", dotDur: 2.7 },
            { id: "e8", d: "M200 355 L470 370", dotDur: 2.9 },

            // AppSync -> DynamoDB
            { id: "e9", d: "M660 240 L700 240", dotDur: 2.3 },

            // API Gateway -> Lambda
            { id: "e10", d: "M660 370 L700 370", dotDur: 2.4 },

            // Lambda -> Azure AI Foundry (AI call)
            {
              id: "e11",
              d: "M880 370 L910 370 L910 215 L940 215",
              dotDur: 3.0,
            },

            // Azure -> Lambda (result/metadata back)
            {
              id: "e12",
              d: "M940 235 L910 235 L910 400 L700 400",
              dotDur: 3.2,
            },

            // Lambda -> S3 (store videos)
            { id: "e13", d: "M880 370 L940 370", dotDur: 2.6 },

            // AppSync -> Clients (data response)
            { id: "e14", d: "M470 215 L200 215", dotDur: 3.1 },

            // API GW -> Clients (job status response)
            { id: "e15", d: "M470 390 L200 390 L200 355", dotDur: 3.3 },
          ],
        },
      },
      {
        key: "high-level-system",
        title: "High level system overview",
        description:
          "Mobile consumes exercises via AppSync backed by DynamoDB and videos in S3. Web triggers video generation via API Gateway + Lambda which calls Azure AI Foundry. Completion triggers updates and notifies web via AppSync subscriptions.",
        svg: {
          viewBox: "0 0 1320 520",
          nodes: [
            // Clients
            {
              id: "mobile",
              type: "box",
              x: 40,
              y: 340,
              w: 200,
              h: 80,
              label: "Mobile App",
              sub: "Patient",
            },
            {
              id: "web",
              type: "box",
              x: 40,
              y: 140,
              w: 200,
              h: 80,
              label: "Web App",
              sub: "Physiotherapist",
            },

            // Auth
            {
              id: "cognito",
              type: "box",
              x: 280,
              y: 240,
              w: 220,
              h: 80,
              label: "Amazon Cognito",
              sub: "Auth + tokens",
            },

            // AWS GraphQL path
            {
              id: "appsync",
              type: "box",
              x: 560,
              y: 340,
              w: 220,
              h: 80,
              label: "AWS AppSync",
              sub: "GraphQL + Subscriptions",
            },
            {
              id: "dynamo",
              type: "box",
              x: 820,
              y: 340,
              w: 240,
              h: 80,
              label: "Amazon DynamoDB",
              sub: "Plans + metadata",
            },
            {
              id: "s3",
              type: "box",
              x: 820,
              y: 440,
              w: 240,
              h: 80,
              label: "Amazon S3",
              sub: "Exercise videos",
            },

            // AWS Web generation path
            {
              id: "apigw",
              type: "box",
              x: 560,
              y: 140,
              w: 220,
              h: 80,
              label: "Amazon API Gateway",
              sub: "REST endpoints",
            },
            {
              id: "lambda",
              type: "box",
              x: 820,
              y: 140,
              w: 240,
              h: 80,
              label: "AWS Lambda",
              sub: "Orchestrate generation",
            },

            // Azure
            {
              id: "azure",
              type: "box",
              x: 1120,
              y: 140,
              w: 260,
              h: 80,
              label: "Azure AI Foundry",
              sub: "Video generation",
            },

            // Optional: status update bridge
            {
              id: "status",
              type: "box",
              x: 1120,
              y: 260,
              w: 260,
              h: 80,
              label: "Status update",
              sub: "Write back + notify",
            },
          ],

          edges: [
            // Auth: Mobile + Web -> Cognito
            {
              id: "e1",
              d: "M240 180 C 255 180, 265 200, 280 260",
              dotDur: 2.0,
            }, // web -> cognito
            {
              id: "e2",
              d: "M240 380 C 255 380, 265 360, 280 300",
              dotDur: 2.1,
            }, // mobile -> cognito

            // Web path: Cognito -> API GW -> Lambda -> Azure
            {
              id: "e3",
              d: "M500 260 C 525 250, 540 220, 560 180",
              dotDur: 2.2,
            }, // cognito -> apigw
            {
              id: "e4",
              d: "M780 180 C 800 180, 805 180, 820 180",
              dotDur: 2.3,
            }, // apigw -> lambda
            {
              id: "e5",
              d: "M1060 180 C 1080 180, 1100 180, 1120 180",
              dotDur: 2.5,
            }, // lambda -> azure

            // Azure returns result -> Lambda (or callback) -> store in S3 + update Dynamo
            {
              id: "e6",
              d: "M1120 200 C 1100 230, 1080 245, 1060 260",
              dotDur: 2.8,
            }, // azure -> status box
            {
              id: "e7",
              d: "M1120 300 C 1040 320, 980 350, 900 440",
              dotDur: 3.0,
            }, // status -> s3 (store video)
            {
              id: "e8",
              d: "M1120 300 C 1040 320, 980 320, 900 380",
              dotDur: 3.1,
            }, // status -> dynamo (metadata)

            // Mobile consumes: AppSync -> Dynamo and S3
            {
              id: "e9",
              d: "M780 380 C 800 380, 810 380, 820 380",
              dotDur: 2.2,
            }, // appsync -> dynamo
            {
              id: "e10",
              d: "M670 420 C 730 420, 770 450, 820 480",
              dotDur: 2.6,
            }, // appsync -> s3 (via urls)

            // Cognito -> AppSync for mobile access
            {
              id: "e11",
              d: "M500 300 C 525 315, 540 335, 560 360",
              dotDur: 2.0,
            }, // cognito -> appsync

            // Notification: write/update triggers AppSync subscriptions -> Web
            {
              id: "e12",
              d: "M820 380 C 740 330, 660 320, 560 340",
              dotDur: 3.2,
            }, // dynamo update -> appsync (conceptual)
            {
              id: "e13",
              d: "M560 340 C 420 320, 310 260, 240 200",
              dotDur: 3.4,
            }, // appsync subscription -> web
          ],
        },
      },
      {
        key: "exercise-generation-flow",
        title: "Exercise generation workflow",
        description:
          "Therapist uploads reference media or prompt, AI generates exercise video, therapist reviews and refines, final exercise is saved and added to a patient plan.",
        svg: {
          viewBox: "0 0 1200 420",
          nodes: [
            {
              id: "therapist",
              type: "box",
              x: 40,
              y: 300,
              w: 180,
              h: 70,
              label: "Physiotherapist",
            },
            {
              id: "web",
              type: "box",
              x: 250,
              y: 300,
              w: 200,
              h: 70,
              label: "Therapix Web App",
            },
            {
              id: "api",
              type: "box",
              x: 500,
              y: 300,
              w: 200,
              h: 70,
              label: "GraphQL API",
            },
            {
              id: "jobs",
              type: "box",
              x: 520,
              y: 120,
              w: 260,
              h: 90,
              label: "AI Generation Jobs",
              sub: "Video + angles",
            },
            {
              id: "storage",
              type: "box",
              x: 820,
              y: 300,
              w: 220,
              h: 70,
              label: "Object Storage",
              sub: "Exercise videos",
            },
            {
              id: "patient",
              type: "box",
              x: 1080,
              y: 300,
              w: 160,
              h: 70,
              label: "Patient",
            },
          ],
          edges: [
            {
              id: "e1",
              d: "M220 335 C 235 335, 245 335, 250 335",
              dotDur: 2.0,
            },
            {
              id: "e2",
              d: "M450 335 C 470 335, 480 335, 500 335",
              dotDur: 2.2,
            },
            {
              id: "e3",
              d: "M600 300 C 600 250, 620 230, 650 200",
              dotDur: 2.6,
            },
            {
              id: "e4",
              d: "M780 200 C 820 220, 840 250, 860 300",
              dotDur: 2.8,
            },
            {
              id: "e5",
              d: "M1040 335 C 1060 335, 1070 335, 1080 335",
              dotDur: 3.0,
            },
          ],
        },
      },
    ],

    notes: [
      "Product inspired by real physiotherapy recovery experience.",
      "Designed to extend beyond static exercise libraries with generative flexibility.",
    ],
  },
  // {
  //   id: 1,
  //   slug: "WasteMatch",
  //   image: waste,
  //   title: "WasteMatch",
  //   category: "web",
  //   cover: wasterBg,

  //   summary:
  //     "Internal documentation portal for teams to publish and maintain product and engineering docs.",
  //   role: "Software Developer",
  //   timeframe: "2023",
  //   status: "Private",

  //   links: {
  //     demo: "",
  //     repo: "",
  //     docs: "",
  //   },

  //   overview: {
  //     problem:
  //       "Documentation was scattered across tools and hard to keep updated.",
  //     solution:
  //       "A structured docs portal with clear navigation and a consistent content format.",
  //     impact:
  //       "Improved onboarding and reduced time spent searching for information.",
  //   },

  //   responsibilities: [
  //     "Designed content structure and page templates",
  //     "Implemented UI components for documentation pages",
  //     "Improved maintainability through reusable layout patterns",
  //   ],

  //   features: [
  //     "Structured documentation with sections and navigation",
  //     "Reusable templates for consistent formatting",
  //     "Search ready information architecture",
  //     "Deployment ready configuration and documentation",
  //   ],

  //   infrastructure: {
  //     architecture: [
  //       "Client: React SPA",
  //       "Optional API: Node.js/Express for dynamic content",
  //       "Storage: repo or CMS backed content",
  //     ],
  //     services: ["React", "Node.js (optional)", "CDN hosting"],
  //     data: ["Static pages or API backed content"],
  //     auth: ["Optional: organization SSO or token based access"],
  //     deployment: ["Netlify or Vercel", "CI via GitHub Actions (optional)"],
  //   },

  //   screenshots: [
  //     { src: shotPlaceholder, alt: "Inenso Docs preview" },
  //     { src: ine, alt: "Inenso Docs preview" },
  //     { src: ine2, alt: "Inenso Docs preview" },
  //     { src: shotPlaceholder, alt: "Inenso Docs preview" },
  //     { src: ine3, alt: "Inenso Docs preview" },
  //     { src: shotPlaceholder, alt: "Inenso Docs preview" },
  //     { src: shotPlaceholder, alt: "Inenso Docs preview" },
  //   ],
  //   architecture: [
  //     {
  //       key: "consent-flow",
  //       title: "Consent flow",
  //       description:
  //         "Referral, token creation, notification via SES/SNS, hosted form, verification back to RDS.",
  //       svg: {
  //         viewBox: "0 0 1200 420",
  //         nodes: [
  //           {
  //             id: "neph",
  //             type: "box",
  //             x: 40,
  //             y: 300,
  //             w: 140,
  //             h: 70,
  //             label: "Nephronet",
  //           },
  //           {
  //             id: "amplify",
  //             type: "box",
  //             x: 220,
  //             y: 300,
  //             w: 160,
  //             h: 70,
  //             label: "AWS Amplify",
  //             sub: "Refer patient",
  //           },
  //           {
  //             id: "rds",
  //             type: "box",
  //             x: 420,
  //             y: 300,
  //             w: 160,
  //             h: 70,
  //             label: "Amazon RDS",
  //             sub: "Store user",
  //           },
  //           {
  //             id: "lambda1",
  //             type: "box",
  //             x: 500,
  //             y: 120,
  //             w: 200,
  //             h: 85,
  //             label: "Lambda",
  //             sub: "Insert trigger",
  //             sub2: "Generate token",
  //           },

  //           {
  //             id: "decision",
  //             type: "diamond",
  //             cx: 820,
  //             cy: 160,
  //             label: "email/sms",
  //           },

  //           {
  //             id: "ses",
  //             type: "box",
  //             x: 930,
  //             y: 70,
  //             w: 220,
  //             h: 70,
  //             label: "Amazon SES",
  //           },
  //           {
  //             id: "sns",
  //             type: "box",
  //             x: 930,
  //             y: 180,
  //             w: 220,
  //             h: 70,
  //             label: "Amazon SNS",
  //           },
  //           {
  //             id: "patient",
  //             type: "box",
  //             x: 930,
  //             y: 300,
  //             w: 140,
  //             h: 70,
  //             label: "Patient",
  //           },
  //           {
  //             id: "form",
  //             type: "box",
  //             x: 1100,
  //             y: 300,
  //             w: 260,
  //             h: 70,
  //             label: "Hosted form",
  //             sub: "User consents",
  //           },
  //           {
  //             id: "lambda2",
  //             type: "box",
  //             x: 1100,
  //             y: 190,
  //             w: 220,
  //             h: 75,
  //             label: "Lambda",
  //             sub: "Verify consent",
  //           },
  //         ],
  //         edges: [
  //           {
  //             id: "e1",
  //             d: "M180 335 C 195 335, 205 335, 220 335",
  //             dotDur: 2.0,
  //           },
  //           {
  //             id: "e2",
  //             d: "M380 335 C 395 335, 405 335, 420 335",
  //             dotDur: 2.1,
  //           },
  //           {
  //             id: "e3",
  //             d: "M500 300 C 500 255, 540 235, 560 205",
  //             dotDur: 2.6,
  //           },
  //           {
  //             id: "e4",
  //             d: "M700 162 C 720 162, 735 162, 760 160",
  //             dotDur: 2.0,
  //           },
  //           {
  //             id: "e5",
  //             d: "M880 150 C 900 135, 915 120, 930 105",
  //             dotDur: 2.4,
  //           },
  //           {
  //             id: "e6",
  //             d: "M880 170 C 900 185, 915 200, 930 215",
  //             dotDur: 2.7,
  //           },
  //           {
  //             id: "e7",
  //             d: "M1040 140 C 1040 190, 1025 245, 1000 300",
  //             dotDur: 2.9,
  //           },
  //           {
  //             id: "e8",
  //             d: "M1070 335 C 1085 335, 1090 335, 1100 335",
  //             dotDur: 3.0,
  //           },
  //           {
  //             id: "e9",
  //             d: "M1230 300 C 1230 280, 1225 270, 1210 265",
  //             dotDur: 3.2,
  //           },
  //           {
  //             id: "e10",
  //             d: "M1100 230 C 900 230, 740 250, 580 300",
  //             dotDur: 3.4,
  //           },
  //           {
  //             id: "e11",
  //             d: "M1100 245 C 760 395, 340 395, 110 370",
  //             dotDur: 4.2,
  //           },
  //         ],
  //       },
  //     },
  //     {
  //       key: "Auth",
  //       title: "Authentication flow",
  //       description:
  //         "User sign up/sign in via Amplify Auth, token validation via Lambda, data access to RDS.",
  //       svg: {
  //         viewBox: "0 0 1200 420",
  //         nodes: [
  //           {
  //             id: "neph",
  //             type: "box",
  //             x: 40,
  //             y: 300,
  //             w: 140,
  //             h: 70,
  //             label: "Nephronet",
  //           },
  //           {
  //             id: "amplify",
  //             type: "box",
  //             x: 220,
  //             y: 300,
  //             w: 160,
  //             h: 70,
  //             label: "AWS Amplify",
  //             sub: "Refer patient",
  //           },
  //           {
  //             id: "rds",
  //             type: "box",
  //             x: 420,
  //             y: 300,
  //             w: 160,
  //             h: 70,
  //             label: "Amazon RDS",
  //             sub: "Store user",
  //           },
  //           {
  //             id: "lambda1",
  //             type: "box",
  //             x: 500,
  //             y: 120,
  //             w: 200,
  //             h: 85,
  //             label: "Lambda",
  //             sub: "Insert trigger",
  //             sub2: "Generate token",
  //           },

  //           {
  //             id: "decision",
  //             type: "diamond",
  //             cx: 820,
  //             cy: 160,
  //             label: "email/sms",
  //           },

  //           {
  //             id: "ses",
  //             type: "box",
  //             x: 930,
  //             y: 70,
  //             w: 220,
  //             h: 70,
  //             label: "Amazon SES",
  //           },
  //           {
  //             id: "sns",
  //             type: "box",
  //             x: 930,
  //             y: 180,
  //             w: 220,
  //             h: 70,
  //             label: "Amazon SNS",
  //           },
  //           {
  //             id: "patient",
  //             type: "box",
  //             x: 930,
  //             y: 300,
  //             w: 140,
  //             h: 70,
  //             label: "Patient",
  //           },
  //           {
  //             id: "form",
  //             type: "box",
  //             x: 1100,
  //             y: 300,
  //             w: 260,
  //             h: 70,
  //             label: "Hosted form",
  //             sub: "User consents",
  //           },
  //           {
  //             id: "lambda2",
  //             type: "box",
  //             x: 1100,
  //             y: 190,
  //             w: 220,
  //             h: 75,
  //             label: "Lambda",
  //             sub: "Verify consent",
  //           },
  //         ],
  //         edges: [
  //           {
  //             id: "e1",
  //             d: "M180 335 C 195 335, 205 335, 220 335",
  //             dotDur: 2.0,
  //           },
  //           {
  //             id: "e2",
  //             d: "M380 335 C 395 335, 405 335, 420 335",
  //             dotDur: 2.1,
  //           },
  //           {
  //             id: "e3",
  //             d: "M500 300 C 500 255, 540 235, 560 205",
  //             dotDur: 2.6,
  //           },
  //           {
  //             id: "e4",
  //             d: "M700 162 C 720 162, 735 162, 760 160",
  //             dotDur: 2.0,
  //           },
  //           {
  //             id: "e5",
  //             d: "M880 150 C 900 135, 915 120, 930 105",
  //             dotDur: 2.4,
  //           },
  //           {
  //             id: "e6",
  //             d: "M880 170 C 900 185, 915 200, 930 215",
  //             dotDur: 2.7,
  //           },
  //           {
  //             id: "e7",
  //             d: "M1040 140 C 1040 190, 1025 245, 1000 300",
  //             dotDur: 2.9,
  //           },
  //           {
  //             id: "e8",
  //             d: "M1070 335 C 1085 335, 1090 335, 1100 335",
  //             dotDur: 3.0,
  //           },
  //           {
  //             id: "e9",
  //             d: "M1230 300 C 1230 280, 1225 270, 1210 265",
  //             dotDur: 3.2,
  //           },
  //           {
  //             id: "e10",
  //             d: "M1100 230 C 900 230, 740 250, 580 300",
  //             dotDur: 3.4,
  //           },
  //           {
  //             id: "e11",
  //             d: "M1100 245 C 760 395, 340 395, 110 370",
  //             dotDur: 4.2,
  //           },
  //         ],
  //       },
  //     },
  //   ],
  //   notes: ["Focus was on clarity, consistency, and ease of updating content."],
  // },
  {
    id: 7,
    slug: "inenso-mobile",
    image: inenso,
    title: "Inenso Mobile App",
    category: "app",
    cover: inensoBg,
    summary:
      "Mobile application concept for internal workflows and user tasks.",
    role: "Developer",
    timeframe: "2023",
    status: "Private",
    video: inensoVg,

    links: { demo: "", repo: "", docs: "" },

    overview: [
      {
        title: "problem",
        description:
          "Teams needed a mobile friendly way to access workflows on the go.",
      },
      {
        title: "solution",
        description:
          "Teams needed a mobile friendly way to access workflows on the go.",
      },
    ],

    stackSummary: [
      { k: "Mobile", v: "Flutter" },
      { k: "Notifications", v: "FCM" },
      { k: "State Management", v: "BLOc" },
      { k: "Mobile Database", v: "Drift" },
      { k: "Payments", v: "PayChangu" },
      { k: "Security", v: "Secure Storage + Biometric Auth" },
    ],

    features: [
      "Mobile friendly flows",
      "Structured navigation",
      "Ready for backend integration",
    ],

    highlights: [
      "Accessibility: Design to be usable accross multiple devices with different display sizes and fonts",
    ],

    screenshots: [{ src: shotPlaceholder, alt: "Inenso mobile preview" }],
    notes: [],
  },

  {
    id: 3,
    slug: "village-bank",
    image: vg,
    title: "Village Bank",
    category: "app",
    cover: vgbg,
    video: vgVideo,

    summary:
      "Mobile app for group savings, loans, and basic analytics for community banking groups.",
    role: "Team Lead, Full Stack",
    timeframe: "Final year project",
    status: "Private",

    stackSummary: [
      { k: "Mobile", v: "Flutter" },
      { k: "Notifications", v: "FCM" },
      { k: "State Management", v: "BLOc" },
      { k: "Database", v: "PostgreSQL" },
      { k: "Auth", v: "Firebase Auth" },
      { k: "API", v: "Java (Spring Boot)" },
      { k: "Payments", v: "Stripe" },
    ],

    links: { demo: "", repo: "", docs: "" },

    overview: [
      {
        title: "Problem",
        description:
          "Community savings groups needed a digital way to track contributions, loans, and balances.",
      },
      {
        title: "Solution",
        description:
          "A mobile app with group accounts, transaction tracking, and simple analytics.",
        impact: "Improved record keeping and visibility into group finances.",
      },
    ],

    responsibilities: [
      "Led feature planning and implementation",
      "Built core app flows and data model",
      "Integrated APIs for secure operations",
    ],

    features: [
      "Group savings and loan tracking",
      "Member management and transactions",
      "Basic analytics and summaries",
      "Secure data handling patterns",
    ],

    infrastructure: {
      architecture: ["Mobile client", "Backend API", "Database"],
      services: ["Flutter", "Firebase or REST API"],
      data: ["Firestore or SQL database (depending on deployment)"],
      auth: ["Email or token based authentication"],
      deployment: ["Firebase hosting for API or server deployment"],
    },

    screenshots: [{ src: shotPlaceholder, alt: "Village Bank preview" }],
    notes: [
      "Built with real world constraints in mind: low bandwidth, usability, reliability.",
    ],
  },
];

export const projectsNav = [
  { name: "all" },
  { name: "web" },
  { name: "app" },
  { name: "design" },
];
